// extracted by mini-css-extract-plugin
module.exports = {"profileWrap":"profileWrap__1gaPX","profileOpenIcon":"profileOpenIcon__2psc6"};